import React, { useState } from 'react';
import { BaseNavLink, Spinner } from '../../base';
import * as S from './cards.styles';

type BaseAction = {
    label: string;
    icon?: React.ReactElement;
    divide?: boolean;
};

type ClickAction = BaseAction & {
    onClick: () => Promise<void> | void;
};

type LinkAction = BaseAction & {
    href: string;
    // Target is "_blank" by default
    target?: '_self';
};

export type CardAction = ClickAction | LinkAction;

export const ActionItem = ({ action }: { action: CardAction }) => {
    const [loading, setLoading] = useState(false);

    if (isClickAction(action)) {
        const handleClick = async () => {
            setLoading(true);

            try {
                await action.onClick();
            } finally {
                setLoading(false);
            }
        };

        return (
            <S.ActionButton variant="unstyled" onClick={handleClick} disabled={loading}>
                <S.IconRow>
                    {loading ? <Spinner size="18px" /> : action.icon}
                    <S.RowLabel>{action.label}</S.RowLabel>
                </S.IconRow>
            </S.ActionButton>
        );
    }

    return (
        <BaseNavLink to={action.href} end={true} target={action.target}>
            {(): React.ReactElement => (
                <S.ActionButton variant="unstyled" disabled={loading}>
                    <S.IconRow>
                        {loading ? <Spinner size="18px" /> : action.icon}
                        <S.RowLabel>{action.label}</S.RowLabel>
                    </S.IconRow>
                </S.ActionButton>
            )}
        </BaseNavLink>
    );
};

export function formatPhoneNumber(phoneNumberString: string) {
    const cleaned = phoneNumberString.replace(/\+1|\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}

function isClickAction(action: CardAction): action is ClickAction {
    return 'onClick' in action;
}
